import { render, staticRenderFns } from "./BoxInfo.vue?vue&type=template&id=443bffc7&scoped=true&lang=html&"
import script from "./BoxInfo.vue?vue&type=script&lang=js&"
export * from "./BoxInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443bffc7",
  null
  
)

export default component.exports